<div
  *ngIf="context.flag && context.activeTab === 'buy-now' && context.showBuyNow"
  style="overflow: hidden"
>
  <p *ngIf="!context.tableData.length" class="m-0">No data found</p>
  <table
    datatable
    [dtOptions]="context.buyNowTableDtOptions"
    class="row-border hover m-0 w-100"
  >
    <thead>
      <tr>
        <th *ngFor="let thead of context.buyNowTheads">{{ thead }}</th>
      </tr>
    </thead>
    <tbody></tbody>
  </table>
</div>
